import { JellyIcon } from '@/icons';
import { cn } from '@/utils/tailwind.util';
export const PURCHASE_TOAST_COPY = {
  title: {
    key: 'common:avatarDecorate.purchaseToastTitle'
  }
} as const;

/**
 * 유료 아이템 구매 성공 토스트.
 *
 * 학생 수신 토스트(`PointReceiveToast`)와 표면(글래스 + shadow-lg)·코인 언어를 공유한다.
 * 다만 수신은 회전+글로우+반짝임으로 축하하고, 구매는 회전만 두어 담백하게 한다 —
 * 카드 획득 연출이 이미 축하를 담당하므로 토스트는 무엇을 샀는지만 한 줄로 확인한다.
 */
export function PurchaseToast({
  message,
  /** react-hot-toast 의 `t.visible`. false 로 바뀌면 퇴장 연출을 태운다. */
  isVisible = true
}: {
  message: string;
  isVisible?: boolean;
}) {
  return <div className={cn('flex min-h-[48px] max-w-[320px] items-center gap-xs rounded-sm bg-opacity-white-10 p-sm shadow-lg backdrop-blur-[2px]', isVisible ? 'animate-point-toast-in' : 'animate-point-toast-out', 'motion-reduce:animate-none')} data-sentry-component="PurchaseToast" data-sentry-source-file="PurchaseToast.tsx">
      <JellyIcon size="md" className="shrink-0 animate-point-coin-celebrate motion-reduce:animate-none" data-sentry-element="JellyIcon" data-sentry-source-file="PurchaseToast.tsx" />
      <span className="min-w-0 text-body-lg-semibold text-default">
        {message}
      </span>
    </div>;
}